import icon from "images/web/access_applet_card/arrow.svg?raw"
import parse from "html-react-parser"

export default function ArrowIcon({ title }) {
  return (
    <span className="svg-icon" title={title}>
      {parse(icon)}
    </span>
  )
}
